import { ACTIVITY_HIERARCHY_MAP, DEFAULT_ACTIVITY_HIERARCHY } from '@constants'
import zipObject from 'lodash/zipObject'

/**
 * This method is parsing hierarchy string that is seperated on basis of heirarchy seperator and will return activity/family/line name
 */
const getActivityHierarchyMap = (hierarchy: any[]) => {
  return zipObject(
    ['activity'].concat(
      ACTIVITY_HIERARCHY_MAP?.[hierarchy[0].name] || DEFAULT_ACTIVITY_HIERARCHY
    ),
    hierarchy
  )
}

export default getActivityHierarchyMap
